import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import Banners from "./Banners";
import ServicesSection from "./ServicesSection";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const ServicesPage = () => {
  const { catSlug, cat } = useParams();
  const [catName, setCatName] = useState(cat ? decodeURIComponent(cat) : null);

  useEffect(() => {
    const slug = catSlug || (cat ? cat : null);
    if (!slug) { document.title = "Salon Services at Home in Gurugram | BeBlushify"; return; }
    axios.get(`${API}/categories`).then((r) => {
      const c = r.data.find((x) => x.slug === slug || x.name.toLowerCase() === slug.toLowerCase());
      const name = c ? c.name : decodeURIComponent(slug);
      setCatName(name);
      document.title = `${name} at Home in Gurugram | BeBlushify`;
      setMeta("description", `Book ${name} services at home in Gurugram with BeBlushify. Trained beauticians, branded products & best prices. Salon@Home for women.`);
    }).catch(() => {});
  }, [catSlug, cat]);

  return (
    <>
      <Navbar />
      <Banners />
      <ServicesSection key={catName || "all"} initialCategory={catName} />
      <Footer />
      <CartDrawer />
    </>
  );
};

export default ServicesPage;
